import { router } from 'src';

import { AuthenticationError } from 'src/model/authentication-error';
import { NavigationService } from 'src/services/navigation-service';

export const handleError = (reason: unknown) => {
  if (!(reason instanceof AuthenticationError)) {
    router.navigate(NavigationService.ERROR, { replace: true });
  }
};
